import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { UspvsCheckComponent } from './uspvs-check.component';
import { InputMaskModule } from 'primeng/inputmask';
import { UspvsRoutes } from './uspvs.routes';
import { RouterModule } from '@angular/router';
import { UspvsService } from './uspvs.service';

import { UspvsModalComponent } from './uspvs-modal.component';
import { ValidationResultsModule } from '../../shared/components/validation-results/validation-results.module';

@NgModule({
    declarations: [
        UspvsCheckComponent,
        UspvsModalComponent
    ],
    providers: [
        UspvsService
    ],
    imports: [
        CommonModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        RouterModule.forChild(UspvsRoutes),
        InputMaskModule,
        ReactiveFormsModule,
        ValidationResultsModule
    ],
    exports: [
    ]
})
export class UspvsHandlerModule { }
